export const isManualRoomCondition = record => !!record && record.occupancyKind == null;

export const isAutomaticRoomCondition = record => !!record && record.occupancyKind != null;
